import { render, staticRenderFns } from "./SeniorDetail.vue?vue&type=template&id=2f349e63&scoped=true"
import script from "./SeniorDetail.vue?vue&type=script&lang=js"
export * from "./SeniorDetail.vue?vue&type=script&lang=js"
import style0 from "./SeniorDetail.vue?vue&type=style&index=0&id=2f349e63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f349e63",
  null
  
)

export default component.exports